import { mount, StartClient } from "solid-start/entry-client";

mount(() => <StartClient />, document);
